const getters = {
  userInfo: state => state.user.userInfo,
  roles: state => state.user.roles,
  isGetUserInfo: state => state.user.isGetUserInfo,
  addRouters: state => state.permission.addRouters,
  operation: state => state.user.operation,
  permissionRoutes: state => state.user.permissionRoutes
};
export default getters;
